module.exports = __webpack_public_path__ + "img/d200807-1.fe9a2318.jpg";